import React from 'react';
import { View } from '@react-pdf/renderer';

/**
 *
 * @param {{
 *  children?: React.ReactNode;
 *  style?: import('@react-pdf/types').Style | (import('@react-pdf/types').Style | undefined)[];
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function Box({ children, ...rest }) {
  return <View {...rest}>{children}</View>;
}
